export default {
    downtimeUrl: "https://it.kodland.tech",
    startPage: {
      title: "🎄 Lezioni di programmazione per bambini dai 5 ai 17 anni.",
      subtitle:
        "I bambini creeranno il loro primo gioco dopo solo una lezione!",
      button: "Prenota una lezione gratuita",
      image: {
        url:  "/welcome/quiz_italy_main_2_pk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      imageMobile: {
        url: "/welcome/quiz_italy_main_2_mobile.png",
        style: {
          width: "100%",
        },
      },
    },
    stopPage: {
        image: "/welcome/quiz_stop_page.jpg",
        title: "Grazie per il tuo interesse verso Kodland! I nostri corsi online sono pensati per ragazzi/e di età compresa tra gli 5 e i 17 anni </p>Si prega di notare che i nostri corsi richiedono una tastiera e un mouse; quindi telefoni, tablet e dispositivi privi di queste caratteristiche non sono compatibili. Per rimanere sempre aggiornato/a sulle nostre novità, puoi seguirci su Instagram https://www.instagram.com/kodland.it/ 💙",
    },
    successPage: {
      title:
        "Perfetto! Vi chiediamo di scegliere un orario comodo per voi, per prenotare la vostra GRATUITA lezione🚀 <br /> Partecipa a una lezione individuale live per introdurre tuo figlio/a al mondo della creazione di videogiochi o coding 🔥",
      subtitle: 'Clicca su "📆 Prenota una lezione" per completare la registrazione',
      button: "📆 Prenota una lezione",
    },
    quizRotateBySteps: {
      1: {
        question:
          "Come trascorre il tempo libero tuo figlio/a?",
        answers: [
            "🎨 Fa delle attività artistiche: disegno, musica, recitazione", 
            "🎮 Gioca con il cellulare o il computer",
            "👍 Gioca a giochi da tavolo",
            "🏅 Fa sport",
            "👨‍👩‍👦 Trascorre del tempo con la famiglia",
            "👩‍🎤 Guarda i cartoni animati",
            "👥 Esce con gli amici"
        ],
      },
      2: {
        question: "Come trascorre il tempo libero tuo figlio/a?",
        answers: [
            "🎮 Il bambino gioca molto", 
            "😜 Il bambino è 'dipendente' da YouTube e TikTokr",
            "👾 Il bambino ha un interesse per la programmazione",
            "❓ Altro"
        ],
      },
      3: {
        question: "Hai un computer fisso/portatile con il quale poter studiare?",
        answers: [
          "❤️ Sì",
          {
            answer: "💙 No",
            stopAnswer: true
          },
        ],
      },
    },
  };
  